/* istanbul ignore file */
export const getTaxFormsStyles = () => ({
  downloadCertLink: {
    marginLeft: 5,
    fontWeight: 'normal',
  },
  taxLabelColClass: {
    display: 'flex',
    alignItems: 'center',
  },
  taxCertificateLabel: {
    width: 'auto !important',
  },
  invalidCertValidationStatus: {
    color: '#A80000',
  },
  inactiveVatStatus: {
    color: '#A80000',
  },
  attestationRadios: {
    display: 'flex',
    gap: '20px',
  },
});
